import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconAdd2 = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          transform="translate(3.1 4.8)"
          d="M16.0588 2.29412V0H0V2.29412H16.0588ZM14.6801 6.30882V9.40588H17.7772V11.2412H14.6801V14.3382H12.8448V11.2412H9.74776V9.40588H12.8448V6.30882H14.6801ZM11.4706 4.58824V6.88235H0V4.58824H11.4706ZM8.02941 11.4706V9.17647H0V11.4706H8.02941Z"
          fill="#143AB1"
        />
      </svg>
    );
  }
);
